import { Button } from '@skylabs-digital/backoffice-kit';
import type { FilesPage } from '../../api/files.api';

/** Previous / Page x de y / Next, el mismo pie que usan todas las tablas paginadas. */
export function Pager({
  meta,
  page,
  onPage,
}: {
  meta: FilesPage['meta'] | null | undefined;
  page: number;
  onPage: (page: number) => void;
}) {
  return (
    <div className="flex items-center justify-end gap-2">
      <Button
        variant="outline"
        size="sm"
        disabled={!meta?.hasPrev}
        onClick={() => onPage(page - 1)}
      >
        Previous
      </Button>
      <span className="text-sm text-muted-foreground">
        Page {page}
        {meta ? ` / ${Math.max(1, meta.totalPages)}` : ''}
      </span>
      <Button
        variant="outline"
        size="sm"
        disabled={!meta?.hasNext}
        onClick={() => onPage(page + 1)}
      >
        Next
      </Button>
    </div>
  );
}
